<template>
    <div>


        <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">
            <div :class="BlockProps.Shadow? 'shadow-sm mb-3' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
                <div class="container" v-bind:style="ContainerPadding">
                    <div class="row">
                        <div class="col col-12">
                            <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.Content" :init="EditorConfig" />
                        </div>
                    </div>
                    <!-- End Row -->
                </div>
            </div>
        </div>

        <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Options</h5>
                    </div>
                    <div class="modal-body">
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <propertybaseeditors :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                        <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'


    export default {
        inheritAttrs: false,
        name: 'BlankCanvas',
        mixins: [ContentBlockBase],
        props: [],
        components: {
        },
        computed:
        {
           
        },
        data() {
            return {  
         
            };
        },
        methods:
        {
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },
          
        },

        setup(props, context)
        {             
            return {} // anything returned here will be available for the rest of the component
        },
        created()
        {           
            EventHub.$on('OnSlideImageUploaded-' + this.BlockProps.UId, this.OnSlideImageUploaded);      
        },
        beforeUnmount()
        {
            EventHub.$off('OnSlideImageUploaded-' + this.BlockProps.UId, this.OnSlideImageUploaded);      
        },
        mounted() {
            nextTick().then(() => {
      
            });
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
</style>

